import { useEffect } from "react";

interface DropboxFile {
  link: string;
  name: string;
}

type UseDropboxChooserReturn = {
  openDropboxChooser: (
    fileTypes: Array<string>,
    onSuccess: (files: readonly DropboxFile[]) => Promise<void>,
    onCancel?: () => void,
  ) => void;
  dropbox: {
    loaded: () => boolean;
    browserSupported: () => boolean;
  };
};

export const useDropboxChooser: (enableDropbox: boolean) => UseDropboxChooserReturn = (
  enableDropbox,
) => {
  useEffect(() => {
    if (!enableDropbox) return;
    if (document.getElementById("dropbox-sdk")) return;

    const script = document.createElement("script");
    script.id = "dropbox-sdk";
    script.src = "https://www.dropbox.com/static/api/2/dropins.js";
    script.setAttribute("data-app-key", window.ENV.DROPBOX_CHOOSER_API_KEY);
    script.async = true;
    document.body.appendChild(script);
  }, [enableDropbox]);

  const openDropboxChooser: UseDropboxChooserReturn["openDropboxChooser"] = (
    fileTypes,
    onSuccess,
    onCancel,
  ) => {
    window.Dropbox?.choose({
      success: (files) => onSuccess(files),
      cancel: onCancel,
      extensions: fileTypes,
      multiselect: false,
      linkType: "direct",
    });
  };

  return {
    openDropboxChooser,
    dropbox: {
      loaded: () => !!window.Dropbox,
      browserSupported: () => window.Dropbox?.isBrowserSupported() ?? false,
    },
  };
};
